import { IStructure } from '@cbgms/api'
import get from 'lodash/get'
import { ExactMatchKey, PartialMatchKey, structTypeToComponentMap } from './StructTypeComponents/struct-type-to-component-map'

/**
 * Queries the given value by a key using the format `Entity.Key`
 *
 * @example
 * ```ts
 * const key = 'Account.Name'
 * const value = {
 *   Account: {
 *     Name: 'John'
 *   }
 * }
 *
 * queryValueByKey(key, value) // returns 'John'
 * ```
 */
function queryValueByKey(value: IStructure, key: string) {
  return (get(value, key) as any as string) || ''
}

function isExactKeyMatch(input: string): input is ExactMatchKey {
  return Object.values(ExactMatchKey).some(value => value === input)
}

function isPartialKeyMatch(input: string): boolean {
  return Object.values(PartialMatchKey).some(value => new RegExp(value).test(input))
}

function queryPartialKey(key: string) {
  const type = new RegExp(PartialMatchKey.Enum).test(key) ? PartialMatchKey.Enum : PartialMatchKey.SliceOfEnum

  return structTypeToComponentMap[type]
}

export function getColumnValue(row: any, key: string, structure: IStructure) {
  const content = queryValueByKey(row, key)
  const type = queryValueByKey(structure, key)

  if (isExactKeyMatch(type)) {
    const component = structTypeToComponentMap[type]

    return { component, content }
  }

  if (isPartialKeyMatch(type)) {
    const component = queryPartialKey(type)

    return {
      component,
      content: {
        value: content,
        type
      }
    }
  }

  return { content }
}
